export enum RenderOptionalsEvents {
  SET_OPTIONALS = '@optinalsToRender/SET_OPTIONALS',
}
